var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Confirmalert',{attrs:{"persistent":true,"isShow":_vm.showOffLineAlert,"content":_vm.off_line_config.error_text,"confirmText":"去登录","cancelText":"取消","onConfirm":_vm.onConfirm,"onCancel":_vm.onCancel}})}
var staticRenderFns = []

export { render, staticRenderFns }